import React from "react";
import { appColors } from "../../utils/appTheme";

/**
 * Spinner de carga al estilo app "Radial".
 * Círculo con borde gris (appColors.line2) y arco superior azul (appColors.blue).
 * Usa el keyframe global `spin` definido en src/index.css.
 *
 * Por defecto se centra dentro de un contenedor con padding vertical (centered).
 * Pasar `centered={false}` para renderizar solo el círculo (p.ej. inline en botones).
 */
const AppSpinner = ({
  size = 36,
  thickness = 3,
  color = appColors.blue,
  trackColor = appColors.line2,
  centered = true,
  style,
}) => {
  const circle = (
    <div
      style={{
        width: size,
        height: size,
        border: `${thickness}px solid ${trackColor}`,
        borderTop: `${thickness}px solid ${color}`,
        borderRadius: "50%",
        animation: "spin 1s linear infinite",
        ...(centered ? null : style),
      }}
    />
  );

  if (!centered) return circle;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "48px 0",
        ...style,
      }}
    >
      {circle}
    </div>
  );
};

export default AppSpinner;
